module.exports = __webpack_public_path__ + "media/images/portfolio-image-a92bf27c64eabfb458d3268c7a4a9bd5.png";